var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00004 0C9.20918 0 11 1.79086 11 4C11 6.20914 9.20918 8 7.00004 8C4.7909 8 3.00004 6.20914 3.00004 4C3.00004 1.79086 4.7909 0 7.00004 0ZM7.00004 2C5.89547 2 5.00004 2.89543 5.00004 4C5.00004 5.10457 5.89547 6 7.00004 6C8.10461 6 9.00004 5.10457 9.00004 4C9.00004 2.89543 8.10461 2 7.00004 2ZM12.6286 11.8377C11.3172 10.0668 9.24656 9 7.00004 9C4.75353 9 2.68293 10.0668 1.3715 11.8377C0.91212 12.458 0.557551 13.1506 0.324219 13.8891L2.2313 14.4916L2.32163 14.2312C2.48403 13.8019 2.70529 13.3972 2.97876 13.0279C3.91693 11.7611 5.39416 11 7.00004 11C8.60592 11 10.0832 11.7611 11.0213 13.0279C11.3495 13.4711 11.6025 13.9652 11.7688 14.4916L13.6759 13.8891L13.5685 13.5755C13.3391 12.9542 13.0223 12.3694 12.6286 11.8377Z",
    fill: "#FF5C6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin2);
export default __webpack_public_path__ + "static/media/Login-2.3b10ac90e97e1323b31d455979f401e8.svg";
export { ForwardRef as ReactComponent };